import { render, staticRenderFns } from "./LayoutLogin.vue?vue&type=template&id=6b516654&scoped=true&"
var script = {}
import style0 from "./LayoutLogin.vue?vue&type=style&index=0&id=6b516654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b516654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b516654')) {
      api.createRecord('6b516654', component.options)
    } else {
      api.reload('6b516654', component.options)
    }
    module.hot.accept("./LayoutLogin.vue?vue&type=template&id=6b516654&scoped=true&", function () {
      api.rerender('6b516654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/LayoutLogin.vue"
export default component.exports